/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
Shopify.Products = (function () {
  var config = {
    howManyToShow: 5,
    howManyToStoreInMemory: 10,
    wrapperId: 'recently-viewed-products',
    templateId: 'recently-viewed-product-template',
    onComplete: null,
    recentlySectionId: null
  };

  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;

  var localStorageHandler = {
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      localStorage.setItem(this.name, JSON.stringify(recentlyViewed));
    },
    read: function () {
      var recentlyViewed = localStorage.getItem(this.name);
      return recentlyViewed ? JSON.parse(recentlyViewed) : [];
    },
    destroy: function () {
      localStorage.removeItem(this.name);
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  var finalize = function () {
    wrapper.show();
    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {
        console.log(error);
      }
    }
  };

var moveAlong = function () {
  if (productHandleQueue.length && shown < config.howManyToShow) {
    fetch(`/products/${productHandleQueue[0]}?sections=${config.recentlySectionId}`)
      .then((r) => r.json())
      .then(
        (d) => {
          const sectionHtml = d[`${config.recentlySectionId}`] || '';

          if (sectionHtml.includes('data-recently-product-visible="true"')) {
            wrapper.append(sectionHtml);
            shown++;
          }

          productHandleQueue.shift();
          moveAlong();
        },
        (e) => {
          console.log(e);
          localStorageHandler.remove(productHandleQueue[0]);
          productHandleQueue.shift();
          moveAlong();
        }
      );
  } else {
    finalize();
  }
};

  return {

    resizeImage: function (src, size) {
      if (size == null) {
        return src;
      }

      if (size == 'master') {
        return src.replace(/http(s)?:/, "");
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
      } else {
        return null;
      }
    },

    showRecentlyViewed: function (params) {
      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read from localStorage.
      productHandleQueue = localStorageHandler.read();

      // Template and element where to insert.
      wrapper = jQuery('#' + config.wrapperId);

      // How many products to show.
      config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

      // If we have any to show.
      if (config.howManyToShow && wrapper.length) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();
      }
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      localStorageHandler.destroy();
    },

    recordRecentlyViewed: function (params) {
      var params = params || {};
      jQuery.extend(config, params);
      var recentlyViewed = localStorageHandler.read();

      // 商品ページかどうか確認
      if (window.location.pathname.indexOf('/products/') !== -1) {

        // 商品ハンドルを抽出
        var match = window.location.pathname.match(/\/products\/([0-9]+)/);
        if (!match) {
          // ハンドルが正しく取得できなかった場合は登録しない
          return;
        }
        var productHandle = match[1];

        // ハンドルが数字のみかどうかチェック
        if (!/^[0-9]+$/.test(productHandle)) {
          // 数字以外が含まれていればスキップ
          return;
        }

        console.log('Product handle:', productHandle);

        // 以下、もともとの処理
        var position = jQuery.inArray(productHandle, recentlyViewed);

        if (position === -1) {
          recentlyViewed.unshift(productHandle);
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }
        localStorageHandler.write(recentlyViewed);
      }
    }
  };
})();